import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { SubscriptionCustomerListItemLoadingDesktop } from './Desktop';
import { SubscriptionCustomerListItemLoadingMobile } from './Mobile';
import { SubscriptionCustomerListItemLoadingTablet } from './Tablet';

export const SubscriptionCustomerListItemLoading: React.FC = (props) => {
  const responsiveItem = useBreakpointValue({
    base: <SubscriptionCustomerListItemLoadingMobile {...props} />,
    sm: <SubscriptionCustomerListItemLoadingTablet {...props} />,
    lg: <SubscriptionCustomerListItemLoadingDesktop {...props} />,
  });

  return responsiveItem;
};
